import React, {Component} from 'react';
import {connect} from "react-redux";
import 'react-bootstrap';

import blogApi from "../../../api/blogApi";
import store from '../../../store/configureStore';
import PhotoArticleBlock from './PhotoArticleBlock';
import { addNotification } from "../../../actions/notificationAction";
import {changeHomeSectionAction} from '../../../actions/homeSectionAction';
import { Businesses } from '../../../config/Helper';
import { lang } from '../../../config/lang';

class PhotoArticleSection extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            arrArticle : []
        }
        this.getArticles = this.getArticles.bind(this);
    }

    componentWillMount() {
        
    }

    componentDidMount() {
        this.getArticles();
    }
  
    componentWillUnmount() {
        
    }
    
    componentDidUpdate() {
        window.articleGallery();
        window.playVideo();  
    }

    componentWillReceiveProps(newProps) {
        if (this.props.language.lang_key !== newProps.language.lang_key) {
            this.getArticles();
        }
    }

    getArticles() {        
        blogApi.getArticles('y').then((json) => {        
            if (json.status === 200) {                
                this.setState({
                    arrArticle : json.data
                });

                if (json.data.length > 0) {
                    store.dispatch(changeHomeSectionAction({particle: true}));
                }
                
                window.contentWayPoint();
                window.initArticleSlider();
            } else {
                store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
            }            
        })
    }

    render() {
        
        if (this.state.arrArticle.length === 0) {
            return (
                <div />
            );
        }

        return (
            <section className="ftco-section ftco-services-blog bg-light" id="photo-article-section" style={{paddingBottom: '4px !important'}}>
                <div className="container">
                    <div className="row justify-content-center heading" style={{marginBottom: '10px !important'}}>
                    <div className="col-md-7 heading-section text-center ftco-animate">
                        <h2 className="mb-4">{this.props.title}</h2>
                        <p>{this.props.sub_title}</p>
                    </div>
                    </div>	
                </div>		
                <div className="container">
                    <div className="row justify-content-start">
                        <div className="col-md-12 heading-section ftco-animate">
                            <div className="row ftco-animates align-items-stretch no-gutters">
                                <div className="col-md-12">
                                    <div className="slide-serial-item owl-carousel service-information photo-article">                
                                        {
                                            this.state.arrArticle.map((article, key) => (
                                                <PhotoArticleBlock 
                                                    key         = {key}                                
                                                    id          = {article.id} 
                                                    title       = {article.title}   
                                                    business    = {Businesses.indexOf('article')}                                   
                                                    medias      = {article.medias} />
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(PhotoArticleSection);